import { createContext } from "react";

export interface ResourceArticleMeta {
  publishedAt: string;
  updatedAt?: string;
  readTime: string;
  title: string;
}

export const ResourceArticleMetaContext = createContext<ResourceArticleMeta | null>(null);
